import React, { useState, useEffect } from 'react';
import { Paper, Button, Grid } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import styles from './ModelInfoDetail.module.scss';
import Carousel from 'react-material-ui-carousel';
import Lightbox from 'react-image-lightbox';
import { connect } from 'react-redux';
import { numberWithCommas } from '../../../../../../utils/numberWithCommas';

const ModelInfoDetail = (props) => {
	const {
		modelId,
		elevationId,
		buildingInfo,
		closeModelInfoDetailModal,
		openModelInfoModal,
		setModelId,
	} = props;
	const [elevation, setElevation] = useState();
	const [tab, setTab] = useState('floorplan');
	const [optionArr, setOptionArr] = useState([]);
	const [options, setOptions] = useState([]);
	const [floorplan, setFloorplan] = useState([]);
	const [openImage, setOpenImage] = useState(false);
	const [photoIndex, setPhotoIndex] = useState(0);

	useEffect(() => {
		let priceList = buildingInfo[modelId]?.priceList;
		if (priceList) {
			let filtedElevations = Object.values(priceList).filter(
				(item) => item.id === elevationId
			);
			if (filtedElevations.length > 0) {
				setElevation(filtedElevations[0]);
			}
		}
	}, [modelId, elevationId, buildingInfo]);

	useEffect(() => {
		let optionsTempArr = [];
		if (elevation) {
			elevation.options?.forEach((option) => {
				option.images?.forEach((image) => {
					optionsTempArr.push({
						optionName: option.name,
						url: image.url,
					});
				});
			});
		}
		setOptionArr(optionsTempArr);
	}, [elevation]);

	useEffect(() => {
		let optionsArr = chunk(optionArr, 2).reduce((acc, item) => {
			return [...acc, { items: item.map((i) => ({ image: i })) }];
		}, []);
		setOptions(optionsArr);
	}, [optionArr]);

	useEffect(() => {
		let floorplanArray = chunk(elevation?.floorplanFiles, 2).reduce(
			(acc, item) => {
				return [...acc, { items: item.map((i) => ({ image: i })) }];
			},
			[]
		);
		setFloorplan(floorplanArray);
	}, [elevation]);

	const handleTabSelect = (e) => {
		let data = e.currentTarget.dataset.tab;
		if (tab !== data) {
			setTab(data);
		}
	};

	const chunk = (arr, chunkSize) => {
		const res = [];
		for (let i = 0; i < arr?.length; i += chunkSize) {
			const chunk = arr.slice(i, i + chunkSize);
			res.push(chunk);
		}
		return res;
	};

	const handleBackToModel = (modelId) => {
		closeModelInfoDetailModal();
		setModelId(modelId);
		openModelInfoModal();
	};

	return (
		<div className={styles.model_info_detail}>
			<Button
				className={styles.back_btn}
				startIcon={
					<ArrowBackIosIcon className={styles.back_btn_icon} />
				}
				size='small'
				onClick={() => handleBackToModel(modelId)}
			>
				Back to elevation list
			</Button>
			<Paper className={styles.paper}>
				<h1 className={styles.title}>
					{modelId} {elevationId}
				</h1>
				<p className={styles.price}>{`Total $${numberWithCommas(
					Number(elevation?.price)
				)}`}</p>
				<div className={styles.content}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<img
								className={styles.elevation_img}
								src={
									elevation?.images
										? elevation?.images[0].url
										: 'https://via.placeholder.com/500x440?text=No+Images'
								}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<div className={styles.floorplan_option}>
								<div className={styles.selector_group}>
									<div
										className={`${styles.selector_btn1}  ${
											tab === 'floorplan'
												? styles.active
												: ''
										}`}
										data-tab='floorplan'
										onClick={(e) => handleTabSelect(e)}
									>
										Floor Plan
									</div>
									<div
										className={`${styles.selector_btn2}  ${
											tab === 'options'
												? styles.active
												: ''
										}`}
										data-tab='options'
										onClick={(e) => handleTabSelect(e)}
									>
										Options
									</div>
								</div>
								<Paper
									className={styles.floorplan_option_paper}
								>
									{tab === 'floorplan' ? (
										<>
											<h3
												className={
													styles.floorplan_option_title
												}
											>
												Review Floor Plan
											</h3>
											<div
												className={
													styles.floorplan_content
												}
											>
												<Carousel
													className={
														styles.floorplan_carousel
													}
													autoPlay={false}
													navButtonsAlwaysVisible={
														true
													}
													navButtonsProps={{
														style: {
															backgroundColor:
																'var(--primary-hover)',
														},
														className: 'navigation',
														'aria-label':
															'button-wrapper',
													}}
													fullHeightHover
													activeIndicatorIconButtonProps={{
														style: {
															color: 'var(--primary-hover)',
														},
													}}
													indicatorIconButtonProps={{
														style: {
															color: 'var(--primary-label)',
														},
														'aria-label':
															'indicator-icon',
													}}
												>
													{floorplan.map((item) =>
														item.items.map(
															(image, index) => {
																return (
																	<div
																		key={
																			index
																		}
																		className={
																			styles.floorplan_item
																		}
																		onClick={() => {
																			setOpenImage(
																				true
																			);
																			setPhotoIndex(
																				index
																			);
																		}}
																	>
																		<img
																			src={
																				image
																					.image
																					.url
																			}
																			style={{
																				maxWidth:
																					'100%',
																			}}
																		/>
																	</div>
																);
															}
														)
													)}
												</Carousel>
												{openImage && (
													<Lightbox
														mainSrc={
															elevation
																?.floorplanFiles[
																photoIndex
															].url
														}
														nextSrc={
															elevation
																?.floorplanFiles[
																(photoIndex +
																	1) %
																	elevation
																		?.floorplanFiles
																		.length
															]
														}
														prevSrc={
															elevation
																?.floorplanFiles[
																(photoIndex +
																	elevation
																		?.floorplanFiles
																		.length -
																	1) %
																	elevation
																		?.floorplanFiles
																		.length
															]
														}
														onMovePrevRequest={() =>
															setPhotoIndex(
																(photoIndex +
																	elevation
																		?.floorplanFiles
																		.length -
																	1) %
																	elevation
																		?.floorplanFiles
																		.length
															)
														}
														onMoveNextRequest={() =>
															setPhotoIndex(
																(photoIndex +
																	1) %
																	elevation
																		?.floorplanFiles
																		.length
															)
														}
														onCloseRequest={() =>
															setOpenImage(false)
														}
													/>
												)}
											</div>
										</>
									) : (
										<>
											<h3
												className={
													styles.floorplan_option_title
												}
											>
												Review Options
											</h3>
											<div
												className={
													styles.option_content
												}
											>
												<Carousel
													className={
														styles.option_carousel
													}
													autoPlay={false}
													navButtonsAlwaysVisible={
														true
													}
													navButtonsProps={{
														style: {
															backgroundColor:
																'var(--primary-hover)',
														},
														className: 'navigation',
														'aria-label':
															'button-wrapper',
													}}
													fullHeightHover
													activeIndicatorIconButtonProps={{
														style: {
															color: 'var(--primary-hover)',
														},
													}}
													indicatorIconButtonProps={{
														style: {
															color: 'var(--primary-label)',
														},
														'aria-label':
															'indicator-icon',
													}}
												>
													{options.map((item) =>
														item.items.map(
															(image, index) => {
																return (
																	<div
																		key={
																			index
																		}
																		className={
																			styles.option_item
																		}
																		onClick={() => {
																			setOpenImage(
																				true
																			);
																			setPhotoIndex(
																				index
																			);
																		}}
																	>
																		<img
																			src={
																				image
																					.image
																					.url
																			}
																			style={{
																				maxWidth:
																					'100%',
																			}}
																		/>
																	</div>
																);
															}
														)
													)}
												</Carousel>
												{openImage && (
													<Lightbox
														mainSrc={
															optionArr[
																photoIndex
															].url
														}
														nextSrc={
															optionArr[
																(photoIndex +
																	1) %
																	optionArr.length
															]
														}
														prevSrc={
															optionArr[
																(photoIndex +
																	optionArr.length -
																	1) %
																	optionArr.length
															]
														}
														onMovePrevRequest={() =>
															setPhotoIndex(
																(photoIndex +
																	optionArr.length -
																	1) %
																	optionArr.length
															)
														}
														onMoveNextRequest={() =>
															setPhotoIndex(
																(photoIndex +
																	1) %
																	optionArr.length
															)
														}
														onCloseRequest={() =>
															setOpenImage(false)
														}
													/>
												)}
											</div>
										</>
									)}
								</Paper>
							</div>
						</Grid>
					</Grid>
				</div>
			</Paper>
		</div>
	);
};

const mapStateToProps = (state) => ({
	buildingInfo: state.siteplanManagement.buildingInfo,
});

export default connect(mapStateToProps)(ModelInfoDetail);
